import { getIngredients } from '@/api/ingredients';
import { ref } from 'vue';

export default function useIngredients() {
  let ingredients = ref([]);

  const fetchIngredients = async () => {
    const fetchedIngredients = await getIngredients();
    ingredients.value = fetchedIngredients.data.map((item) => ({
      key: item.id,
      value: item.attributes.name + ' (' + item.attributes.code + ')',
      code: item.attributes.code,
    }));
  };

  return {
    ingredients,
    fetchIngredients,
  };
}
